<template>
    <v-container>
        <v-card outlined>
            <v-card-title class='headline'>References:</v-card-title>
            <v-card-actions>
                <v-row class='mx-2' dense>
                    <v-col cols='12'>
                        <v-list
                            single-line
                            dense
                            v-for='item in type.references'
                            :key='item'
                        >
                            <v-list-item>
                                <v-list-item-icon>
                                    <v-icon color='secondary'>mdi-bookmark-outline</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title>{{ item }}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-col>
                </v-row>
            </v-card-actions>
        </v-card>
        
    </v-container>
</template>

<script>
export default {
    props: {
        type: Object
    }
    
}
</script>